import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule } from '@angular/core';
import { Cms } from '@impact/data';
import { NavigationModule } from '../../navigation/navigation.module';
import { SpotsUiModule } from '../../spots/spots-ui.module';

@Component({
    selector: 'app-navigation-section-page',
    templateUrl: './navigation-section-page.html',
    styleUrls: ['./navigation-section-page.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationSectionPageComponent {
    public static ref = 'navigationSectionPage';

    @Input() data?: Cms.NavigationSectionPage;
}

@NgModule({
    declarations: [NavigationSectionPageComponent],
    imports: [
        CommonModule,
        SpotsUiModule,
        NavigationModule
    ]
})
class NavigationSectionPageModule { }

export const LazyComponent = NavigationSectionPageComponent;
